import { BigNumber } from "../external/bignumber.js/bignumber.js";
import { BN_ZERO } from "../constants/index.js";
function fNumber(number, decimals = 0) {
  if (typeof number === "string" && number === "-") return number;
  return bnOrZero(number).toFormat(decimals);
}
function fAmount(number) {
  if (typeof number === "string" && number === "-") return number;
  return bnOrZero(number).toFormat(2, BigNumber.ROUND_DOWN);
}
const numberOrZero = (input) => {
  switch (typeof input) {
    case "number":
      return input;
    default:
      return isNumber(input) ? Number(input) : 0;
  }
};
const isNumber = (input) => {
  return !isNaN(input) && isFinite(input);
};
const parseBN = (input, defaultValue) => {
  if (!input && input !== 0) return defaultValue;
  if (typeof input === "string") input = input.trim().replace(/,/g, "");
  const result = BigNumber.isBigNumber(input) ? input : new BigNumber(input);
  if (!result.isFinite() || result.isNaN()) return defaultValue;
  return result;
};
const bnOrZero = (input, defaultValue = BN_ZERO) => {
  return parseBN(input, defaultValue);
};
export {
  bnOrZero,
  fAmount,
  fNumber,
  isNumber,
  numberOrZero,
  parseBN
};
